module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/choose-sourcedout/work-your-way-234d4ef34c01e993b0c1e46a137f499d.png";